<template>
  <div class="index">
    <div class="centered types-addition" v-if="documentTypes">
      <draggable v-model="documentTypesCopy" :options="{ disabled: editableDocumentType !== null }">
        <span v-for="item in documentTypesCopy" @click="getDocumentType(item.id)" class="document-wrapper">
          <router-link :key="item.id"
          active-class="is-active"
          v-if="editableDocumentType !== item.id"
          :to="{ name: 'Document', params: { id: item.id }  }"
          class="city-title">{{item.name}}
          </router-link>
          <span v-else class="edit-document-wrapper">
            <a class="delete hide-edit-document" @click="toggleEditDocumentType(item.id)"></a>
            <b-input v-model="newDocumentTypeName"
            class="edit-document-input"></b-input>
            <img src="/static/img/icons/apply.svg" class="apply-icon is-medium" @click="handleUpdateDocumentTypes"/>
          </span>
          <img src="/static/img/icons/edit.svg" class="edit-icon" @click="toggleEditDocumentType(item.id)"/>
        </span>
      </draggable>
      <span class="button-wrapper" @click="toggleTypeAddition" v-if="!typeAdditionVisible">
        <a class="button is-info">+</a> Добавить новый тип
      </span>
      <b-field class="city-addition-input" v-else>
          <b-input v-model="typeName"></b-input>
          <span class="city-addition-button is-primary button" @click="handleAddType">Добавить</span>
          <span class="city-addition-button is-warning button" @click="toggleTypeAddition">Отмена</span>
      </b-field>
    </div>
    <div class="documents-container" v-if="documentType">
      <div class="documents">
        <div class="save-content-button centered">
          <button class="button save-content" @click="handleSaveDocuments()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
        </div>
        <table v-if="documentsData && documentsData.length">
          <thead>
            <tr>
              <td>№ документа</td>
              <td>Название документа</td>
              <td>Период актуальности информации</td>
              <td>Дата раскрытия</td>
            </tr>
          </thead>
          <draggable class="fake-table" v-model="documentsData">
            <DocumentItem v-for="document in documentsData" :key="document.id" :document="document"/>
          </draggable>
        </table>
        <div class="centered">
          <span class="button-wrapper link" @click="handleAddDocument(documentType.id)">
            <a class="button is-info">+</a> Добавить документ
          </span>
        </div>
        <div class="columns">
          <div class="column delete-document-type" @click="deleteDocumentType(documentType.id)">
            <span>Удалить</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentItem from 'components/Documents/DocumentItem'
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import deepcopy from 'deepcopy'
import uuidv4 from 'uuid/v4'

export default {
  name: 'License',
  data () {
    return {
      typeAdditionVisible: false,
      typeName: '',
      newDocumentTypeName: '',
      editableDocumentType: null,
      disabled: false
    }
  },
  computed: {
    ...mapState(['documentTypes', 'documentType']),
    documentsData: {
      get () {
        return deepcopy(this.documentType.documents)
      },
      set (val) {
        const valCopy = deepcopy(val)
        for (let i = 0; i < valCopy.length; i++) {
          valCopy[i].order = i
        }
        this.updateDocumentsOrder(valCopy)
      }
    },
    documentTypesCopy: {
      get () {
        return deepcopy(this.documentTypes)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateDocumentTypes(val)
      }
    }
  },
  created () {
    const id = this.$route.params.id
    this.getDocumentsTypes(id)
    if (id) {
      this.getDocumentType(id)
    }
  },
  methods: {
    ...mapActions(['getDocumentsTypes', 'addDocument', 'deleteDocumentType',
      'getDocumentType', 'addDocumentType', 'updateDocumentTypes', 'saveDocuments',
      'updateDocumentsOrder']),
    toggleTypeAddition () {
      this.typeAdditionVisible = !this.typeAdditionVisible
    },
    handleSaveDocuments () {
      this.disabled = true
      this.saveDocuments(this.documentType)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    },
    handleAddType () {
      if (this.typeName) {
        this.addDocumentType(this.typeName)
        this.typeName = ''
        this.toggleTypeAddition()
      }
    },
    toggleEditDocumentType (id) {
      if (id === this.editableDocumentType) {
        id = null
        this.newDocumentTypeName = ''
      } else {
        const docType = this.documentTypesCopy.find(d => d.id === id)
        this.newDocumentTypeName = docType.name
      }
      this.editableDocumentType = id
    },
    handleUpdateDocumentTypes () {
      const docType = this.documentTypesCopy.find(a => a.id === this.editableDocumentType)
      this.editableDocumentType = null
      docType.name = this.newDocumentTypeName
      this.newDocumentTypeName = ''
      this.updateDocumentTypes(this.documentTypesCopy)
    },
    handleAddDocument (type) {
      this.addDocument({
        type,
        id: uuidv4(),
        document_type_id: this.documentType.id
      })
    }
  },
  components: { DocumentItem, draggable },
  watch: {
    documentType: {
      deep: true,
      handler (val) {
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style scoped>
@import "../../global.css";
.documents-container {
  background: #eee;
  min-width: 910px;
  padding: 90px 90px 60px;
}
.delete-document-type {
  max-width: 200px;
  margin: 40px auto 20px;
  background: red;
  text-align: center;
  color: white;
  cursor: pointer;
}
.documents {
  background: white;
  padding: 10px 40px;
  margin: 0 auto;
  max-width: 1368px;
  min-width: 600px;
  overflow-x: auto;
  overflow-y: hidden;
}
.documents thead {
  color: darkgray;
  font-size: 14px;
}
.documents thead :not(:first-child) {
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// Documents.vue?0b8e2c6a